import Vue from 'vue'
import App from './App.vue'
import router from '@/router'

import { store } from './vuex'
import './ml'

Vue.config.productionTip = false
//Vue.prototype.$url = 'https://local.renner.com.br/';
Vue.prototype.$url = 'https://fashion.vrglass.com/';
Vue.prototype.$url_oracle = 'https://ademosrv0033c1dev-store.demoservices011.commerce.oraclepdemos.com';
Vue.prototype.$logged = false;


new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')


